export const Gallery = ({ data = [], onImageClick }) => (
  <section id="work" className="section section--work-v7" aria-labelledby="work-title">
    <div className="site-container">
      <div className="work-title-v7" data-motion><p className="eyebrow">SELECTED WORK</p><h2 id="work-title">작업을 나열하지 않고,<br/><span>하나의 장면으로 보여줍니다.</span></h2></div>
      {data.map((item,index)=><article className="work-scene-v7" key={item.title} data-motion>
        <div className="work-scene-meta"><span>0{index+1}</span><p>{item.category}</p><h3>{item.title}</h3><div>{item.services.map(s=><b key={s}>{s}</b>)}</div></div>
        <button className="work-visual-v7" onClick={()=>onImageClick(item)} aria-label={`${item.title} 크게 보기`}><img src={`/${item.smallImage}`} alt={`${item.title} 프로젝트`}/><span>VIEW<br/>PROJECT ↗</span></button>
        <p className="work-summary-v7">{item.summary}</p>
      </article>)}
    </div>
  </section>
);
